import React from "react";
import MapComponent from "../../components/Map/Map";
// import Povprasevanje from "../../components/Povprasevanje/";
import AsyncImage from "../../components/AsyncImage";

import ReactMarkdown from "react-markdown";

import styles from "./kontakt.module.css";

export default ({ data }) => {
  const {
    contentfulStran: {
      tekst: { tekst },
      slika
    }
  } = data;

  return (
    <div>
      <div className={styles.infoPanel}>
        <AsyncImage
          className={styles.header}
          imageUrl={slika.file.url}
          alt="slika dvorane"
          placeholderColor="#ecf0f1"
        />
        <div className={styles.infoPanelText}>
          <ReactMarkdown source={tekst} />
        </div>
      </div>
      <MapComponent
        googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyBZZyaV2kdRP9R_6HtWrkysjZYcfRbHlnw&libraries=geometry,drawing,places"
        loadingElement={
          <div
            style={{
              width: "100%",
              height: "400px",
              backgroundColor: "#222",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            Zemljevid se nalaga...
          </div>
        }
        containerElement={
          <div
            style={{
              border: "1px solid rgba(0, 0, 0, .25)",
              width: "100%",
              height: "400px"
            }}
          />
        }
        mapElement={<div style={{ width: "100%", height: "100%" }} />}
        lat={46.04852469999999}
        lng={14.549168699999996}
      />
      {/* <Povprasevanje /> */}
    </div>
  );
};

export const query = graphql`
  query KontaktQuery {
    contentfulStran(id: { eq: "c67ogWYgZs4Wmeoo4Mci2Ak" }) {
      naslov
      tekst {
        tekst
      }
      slika {
        file {
          url
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/kontakt/index.js